<template>
	<div style="height:100vh;">
		<div class="d-flex flex-wrap justify-content-center align-items-center w-100 h-100">
			<div id="container-instant" class="d-flex justify-content-center py-4 p-md-4 p-lg-5" v-if="account" style="width:50%;">
				<transition name="fade" mode="out-in">
					<div class="col-12 d-flex flex-column align-items-center justify-content-center">
						<div class="d-flex justify-content-center align-items-center logo-container mb-5">
							<img class="logo" :src="logo_url" alt="logo-instant">
						</div>
						<div v-show="step === 1" class="col form">
							<div class="form-group">
								<label for="name">Nome completo</label>
								<input 
									type="text"
									id="name"
									class="form-control"
									:class="{ 'is-invalid': $v.form.name.$error }"
									v-model="$v.form.name.$model"
									autocomplete="new-name"
								>
								<div class="invalid-feedback">
									Obrigatório
								</div>
							</div>
							<div class="form-group">
								<label for="birth_date">Data de Nascimento</label>
								<input 
									type="phone"
									id="birth_date"
									v-mask="[ '##/##/####' ]"
									class="form-control"
									:class="{ 'is-invalid': $v.form.birth_date.$error }"
									v-model="$v.form.birth_date.$model"
									placeholder="DD/MM/AAAA"
									autocomplete="new-birth_date"
								>
								<div class="invalid-feedback" v-if="!$v.form.birth_date.required">
									Obrigatório
								</div>
								<div class="invalid-feedback" v-else-if="!$v.form.birth_date.minValue">
									Deve ser posterior à 01/01/1930
								</div>
								<div class="invalid-feedback" v-else-if="!$v.form.birth_date.maxValue">
									Deve ser anterior à {{ today_minus_18_years }}
								</div>
							</div>
							<div class="form-group">
								<label for="cpf">CPF</label>
								<input 
									type="phone"
									id="cpf"
									v-mask="['###.###.###-##']"
									class="form-control"
									:class="{ 'is-invalid': $v.form.cpf.$error }"
									v-model="$v.form.cpf.$model"
									autocomplete="username"
								>
								<div class="invalid-feedback" v-if="!$v.form.cpf.required">
									Obrigatório
								</div>
								<div class="invalid-feedback" v-else-if="!$v.form.cpf.CPFValidation">
									CPF Inválido
								</div>
							</div>
							<div class="form-group">
								<label for="cel_phone">Celular</label>
								<input 
									type="phone"
									id="cel_phone"
									v-mask="[ '(##) ####-####', '(##) #####-####' ]"
									class="form-control"
									:class="{ 'is-invalid': $v.form.cel_phone.$error }"
									v-model="$v.form.cel_phone.$model"
									autocomplete="new-cel_phone"
								>
								<div class="invalid-feedback">
									Obrigatório
								</div>
							</div>
							<div class="form-group">
								<label for="password">Senha</label>
								<input 
									type="password"
									id="password"
									class="form-control"
									:class="{ 'is-invalid': $v.form.password.$error }"
									v-model="$v.form.password.$model"
									autocomplete="new-password"
								>
								<div class="capslock-alert" v-if="capslock_on">
									CAPSLOCK ligado!
								</div>
								<div class="invalid-feedback" v-if="!$v.form.password.required">
									Obrigatório
								</div>
								<div class="invalid-feedback" v-else-if="!$v.form.password.minLength">
									Mínimo de 6 caractéres
								</div>
							</div>
							<div class="form-group d-flex align-items-center">
								<input 
									type="checkbox"
									id="is_doctor"
									class="form-control ml-1 mr-2"
									v-model="is_doctor"
								>
								<label for="is_doctor">Sou médico</label>
							</div>
						</div>
						<div v-show="step === 2" class="col doctor-form">
							<div class="form-group">
								<label for="professional_advice">Conselho Profissional</label>
								<v-select
									:class="{ 'is-invalid': $v.doctor_form.professional_advice.$error }"
									v-model="$v.doctor_form.professional_advice.$model"
									:options="constants.PROFESSIONAL_ADVICE"
									:reduce="o => o.code"
									:get-option-label="o => `${o.code} - ${o.label}`"
									placeholder="BUSCAR CONSELHO"
									:clearable="true"
								>
									<template #no-options>
										NENHUMA OPÇÃO ENCONTRADA.
									</template>
								</v-select>
								<div class="invalid-feedback">
									Obrigatório
								</div>
							</div>
							<div class="data-group">
								<div class="form-group col-md-10 pl-0">
									<label for="number">Número</label>
									<input 
										type="text"
										id="number"
										class="form-control"
										:class="{ 'is-invalid': $v.doctor_form.number.$error }"
										v-model="$v.doctor_form.number.$model"
										placeholder="NÚMERO"
									>
									<div class="invalid-feedback">
										Obrigatório
									</div>
								</div>
								<div class="form-group col-md-2 p-0">
									<label for="uf_professional_advice">UF</label>
									<v-select
										:class="{ 'is-invalid': $v.doctor_form.uf_professional_advice.$error }"
										v-model="$v.doctor_form.uf_professional_advice.$model"
										:options="ufs"
										:reduce="o => o.initials"
										:get-option-label="o => `${o.initials}`"
										placeholder="UF"
										:clearable="true"
									>
										<template #no-options>
											NENHUMA OPÇÃO ENCONTRADA.
										</template>
									</v-select>
									<div class="invalid-feedback">
										Obrigatório
									</div>
								</div>
							</div>
							<div class="form-group">
								<label for="cbo">CBO</label>
								<v-select
									:class="{ 'is-invalid': $v.doctor_form.cbo.$error }"
									v-model="$v.doctor_form.cbo.$model"
									:options="constants.CBO"
									:reduce="o => o.code"
									:get-option-label="o => `${o.code} - ${o.label}`"
									placeholder="CÓDIGO OU NOME DA OCUPAÇÃO"
									:clearable="true"
								>
									<template #no-options>
										NENHUMA OPÇÃO ENCONTRADA.
									</template>
								</v-select>
								<div class="invalid-feedback">
									Obrigatório
								</div>
							</div>
							<div class="data-group">
								<div class="form-group col-md-10 pl-0">
									<label for="rqe">RQE</label>
									<input 
										type="text"
										id="rqe"
										class="form-control"
										v-model="doctor_form.rqe"
										placeholder="RQE"
									>
									<div class="invalid-feedback">
										Obrigatório
									</div>
								</div>
								<div class="form-group col-md-2 p-0">
									<label for="uf_rqe">UF</label>
									<v-select
										v-model="$v.doctor_form.uf_rqe.$model"
										:options="ufs"
										:reduce="o => o.initials"
										:get-option-label="o => `${o.initials}`"
										placeholder="UF"
										:clearable="true"
										:class="{ 'is-invalid': $v.doctor_form.uf_rqe.$error }"
									>
										<template #no-options>
											NENHUMA OPÇÃO ENCONTRADA.
										</template>
									</v-select>
									<div class="invalid-feedback">
										Obrigatório
									</div>
								</div>
							</div>
							<div class="form-group">
								<label for="line_one">Linha 1</label>
								<Editor
									v-model="$v.doctor_form.line_one.$model"
									:class="{ 'is-invalid': $v.doctor_form.line_one.$error }"
									:maxlength="stampEditorMaxLength"
									toolbar-preset="stamps"
									:size-options="stampEditorSizeOptions"
								/>
								<div class="invalid-feedback">
									Obrigatório
								</div>
							</div>
							<div class="form-group">
								<label for="line_two">Linha 2</label>
								<Editor
									v-model="doctor_form.line_two"
									:maxlength="stampEditorMaxLength"
									toolbar-preset="stamps"
									:size-options="stampEditorSizeOptions"
								/>
							</div>
							<div class="form-group">
								<label for="line_three">Linha 3</label>
								<Editor
									v-model="doctor_form.line_three"
									:maxlength="stampEditorMaxLength"
									toolbar-preset="stamps"
									:size-options="stampEditorSizeOptions"
								/>
							</div>
						</div>
						<div class="col d-flex flex-column align-items-center">
							<button class="btn btn-primary py-2 my-3"
								@click="NextStep()">
								<span class="text-uppercase">
									Continuar
								</span>
							</button>
							<span class="" v-if="step !== 1">
								<a class="link" @click="BackStep()">voltar</a>
							</span>
						</div>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
	import Swal from 'sweetalert2'
	import { required, minLength, sameAs, requiredIf } from 'vuelidate/lib/validators'
	import { mapActions } from 'vuex'
	import moment from 'moment'
	import { PROFESSIONAL_ADVICE, CBO } from '@/constants'
	import Editor from './../shared/Editor.vue'
	const CPFValidation = (value, vm) => window.helpers.ValidaCPF(value)

	export default {
		name: 'Index',
		components: {
			Editor
		},
		props: {
			token: 	{
				type: 		[String, Number],
				default: 	null
			}
		},
		data () {
			return {
				defaultAvatar: 		require('../../assets/img/profile.png'),
				step: 				1,
				account: 			null,
				exihibitAvatar: 	null,
				form: 				{
					name: 					'',
					birth_date: 			'',
					cpf: 					'',
					cel_phone: 				'',
					password: 				'',
				},
				is_doctor: 					false,
				doctor_form:		{
					professional_advice: 	'',
					number:					'',
					uf_professional_advice: '',
					cbo: 					'',
					rqe:					'',
					uf_rqe:					'',
					line_one:				'',
					line_two:				'',
					line_three:				'',
				},
				capslock_on:		false,
				logo_url:			window.logo_url,
				ufs:				window.statesBR,
				constants: {
					PROFESSIONAL_ADVICE,
					CBO
				},
				stampEditorSizeOptions: ['10px', '12px'],
				stampEditorMaxLength: 191,
			}
		},
		validations() {
			let obj = {
				form: 			{
					name: 			{
						required
					},
					birth_date: 	{
						required,
						minValue: 	(val) => {
							let validate = false

							if(val) {
								const year_regex = val.match(/\/\d{4}$/g)
								const year = year_regex && year_regex.length ? year_regex[0].slice(-4) : null
	
								if(year && year !== '0000') {
									const value = moment(val, 'DD/MM/YYYY')
									const minDate = moment('1930-01-01')
									
									validate = value > minDate
								}
							}
								
							return validate
						},
						maxValue: 	(val) => {
							let validate = false

							if(val) {
								validate = moment(val, 'DD/MM/YYYY') < moment().subtract(18, 'years')
							}

							return validate
						}
					},
					cpf: 			{
						required,
						CPFValidation //if
					},
					cel_phone: 		{
						required
					},
					password: 		{
						required,
						minLength: 	minLength(6)
					},
				},
				doctor_form: {
					professional_advice: {
						required: requiredIf(() => this.is_doctor)
					},
					number: {
						required: requiredIf(() => this.is_doctor)
					},
					uf_professional_advice: {
						required: requiredIf(() => this.is_doctor)
					},
					cbo: {
						required: requiredIf(() => this.is_doctor)
					},
					line_one: {
						required: requiredIf(() => this.is_doctor)
					},
					uf_rqe: {
						required: requiredIf(() => this.doctor_form.rqe && this.is_doctor)
					}
				}
			}

			return obj;
		},
		computed: {
			today_minus_18_years() {
				return moment().subtract(18, 'years').format('DD/MM/YYYY')
			},
		},
		watch: {
			'form.name': {
				handler(val) {
					if(val) {
						this.doctor_form.name_stamp = val
					}
				},
			}
		},
		methods: {
			...mapActions('system', [
				'StartLoading', 'FinishLoading'
			]),
			BackStep() {
				switch(this.step) {
					case 1: 
					break
					case 2:
						this.step 	= 1
					break;
				}
			},
			async NextStep() {
				switch(this.step) {
					case 1: 
						this.$v.form.$touch()

						if(!this.$v.form.$invalid) {
							if(this.is_doctor) {
								this.step = 2;

								return;
							}

							await this.Save();
						}
					break;
					case 2:
						this.$v.doctor_form.$touch()

						if(!this.$v.doctor_form.$invalid) {
							await this.Save();
						}
					break;
				}
			},
			GetAccountByToken()
			{
				const vm = this

				vm.StartLoading()

				return window.api.call('post', '/website/get-account-by-token', {
						token: 	this.token,
						type: 	'api'
					})
					.then(({data}) => {

						if(data.response)
						{	
							this.account 		= data.account

							this.form.name 		= data.account.name

						}else{

							Swal.fire({
								icon: 				'error',
								title: 				'Ops...',
								text: 				'Houve um erro ao obter, contate o suporte.',
								showConfirmButton: 	true,
								preConfirm: () => {
									this.$router.push({ name: 'Login' })
								}
							})
						}
					})
					.finally(() => {
						vm.FinishLoading()
					})
					/*.catch(({resp}) => {

						Swal.fire({
							icon: 				'error',
							title: 				'Ops...',
							text: 				'Token inválido, contate o suporte.',
							showConfirmButton: 	true,
							preConfirm: () => {
									this.$router.push({ name: 'Login' })
							}
						})
					})*/
			},
			RemAvatar()
			{
				this.form.avatar.file 	= ''
				this.form.avatar.name 	= ''

				this.exihibitAvatar     = null
			},
			GetAvatar(event)
			{
            	const reader 			= new FileReader()
	            const me 				= this
	            let file 				= event.target.files[0]

	            if(file)
	            {
	            	Swal.showLoading()

	            	this.form.avatar.file	= file
		            this.form.avatar.name	= file.name

		            reader.onload 			= e => me.exihibitAvatar = e.target.result

		            reader.readAsDataURL(file)

		            Swal.close()
	            }
			},
			async Save()
			{
				Swal.showLoading()

				// const formData 		= new FormData()

				// if(this.exihibitAvatar) {
				// 	formData.append('avatar', this.form.avatar.file, this.form.avatar.name)
				// }

				this.form 			= {
					...this.form,
					...this.doctor_form
				};

				this.form.is_doctor = this.is_doctor;

				// await Object.keys(this.form).map((key, index) => {
				// 	if(key != 'avatar') {
				// 		formData.append(key.toString(), this.form[key])
				// 	}
				// })

				// formData.append('account_id', this.account.id)

				window.axios.post(`/website/complete-registration`, {
					account: { 
						...this.form,
						id: this.account.id
					}
				})
					.then(({data}) => {
						if(data.response)
						{
							Swal.fire({
								icon: 				'success',
								title: 				'Pronto !',
								text: 				'Agora você possui acesso ao sistema e será redirecionado.',
								showConfirmButton: 	true,
								preConfirm: () => {
									window.location.href = `${process.env.VUE_APP_MANAGEMENT_URL}/auth/token/${data.bridge_key}`
								}
							})
						} else {
							let message 		= 'Houve um erro ao concluir, contate o suporte.'

							if(data.exists) {
								switch(data.exists) {
									case 'document':
										message 	= 'Este CPF já esta cadastrado, verique se ja possui cadastro com outro email.'
									break
									case 'fone':
										message 	= 'Este telefone já esta cadastrado, verique se ja possui cadastro com outro email.'
									break
								}
							}

							Swal.fire({
								icon: 				'error',
								title: 				'Ops...',
								text: 				message
							})
						}
					})
					.catch(({response}) => {
						Swal.fire({
							icon: 				'error',
							title: 				'Ops...',
							text: 				'Houve um erro ao concluir, contate o suporte.'
						})
					})
			}
		},
		beforeMount()
		{
			document.addEventListener('keyup', (e) => {
				if (e.getModifierState && e.getModifierState('CapsLock')) {
					this.capslock_on = true
				} else {
					this.capslock_on = false
				}
			});

			this.GetAccountByToken()
		}
	}
</script>

<style lang="scss" scoped>
input#is_doctor {
	width: 1.2rem;
}

#container-instant {
	position: unset;
	top: 0;
	left: 0;
	transform: translate(0);
	max-width: none;
}

#container-instant .form .form-group {

}

#container-instant .doctor-form .form-group {
	margin-bottom: 1.6rem;
}

select {
	background-color: #E5E5E5;
	height: calc(1.5em + 0.75rem + 3px);
	border: 1.5px solid #ccc;
	outline: 1.5px solid #ccc;
    border-radius: 8px;
	padding-left: 8px;
}

.btn-primary {
	height: 38.8px;
	width: 100%;
}

.data-group {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	/* gap: 0.5rem; */
}

::v-deep .v-select {
	--vs-controls-color: var(--fontColor);
	--vs-border-color: var(--borderColor);
	--vs-border-width: 1px;
	--vs-border-radius: 8px;

	--vs-line-height: 1.4;
	--vs-font-size: 0.875rem;

	--vs-bg: var(--backgroundColor);
	--vs-selected-color: var(--fontColor);

	--vs-search-input-color: #495057;
	--vs-search-input-bg: var(--newBackground);
	--vs-search-input-placeholder-color: #495057;

	--vs-dropdown-bg: var(--optionBackgroundColor);
	--vs-dropdown-color: var(--fontColorOption);
	--vs-dropdown-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);

	--vs-actions-padding: 1px 6px 0 3px;

	--vs-dropdown-option-padding: 4px 16px;
	--vs-dropdown-option-color: var(--fontColorOption);
	--vs-dropdown-option--active-bg: var(--optionBackgroundColor);
	--vs-dropdown-option--active-color: var(--fontColor);

	--vs-state-disabled-bg: var(--backgroundColorInactive);
	--vs-state-disabled-color: var(--fontColorInactive);
	--vs-state-disabled-controls-color: var(--fontColorInactive);
	--vs-state-disabled-cursor: not-allowed;

	.vs__dropdown-toggle {
		background-color: var(--backgroundColor);
		border-color: var(--borderColor);
		height: 2.438rem;
		padding: 0.375rem 0.75rem;
		align-items: center;
	}

	.vs__dropdown-menu {
		min-width: 2.5rem;
	}

	.vs--open .vs__dropdown-toggle,
	.vs__dropdown-toggle:focus-within,
	.vs__dropdown-toggle:focus {
		background-color: var(--backgroundColor) !important;
		border-color: var(--borderColor) !important;
	}

	.vs__selected-options {
		align-items: center;
		flex-wrap: nowrap;
	}

	.vs__selected {
		margin: 0;
		padding: 0;
		color: var(--fontColor);
	}

	&.vs--open .vs__selected {
		color: var(--fontColor);
	}

	.vs__search,
	.vs__search:focus {
		color: #495057;
		background-color: transparent;
		font-size: 0.875rem;
		font-weight: bolder;
		margin: 0 !important;
		padding: 0;
		line-height: 1.5;
		opacity: 0.40;
	}

	.vs__dropdown-menu {
		background-color: var(--optionBackgroundColor);
		border-color: var(--borderColorActiveNotSelected);
	}

	.vs__dropdown-option {
		color: var(--fontColor);
		font-size: var(--vs-font-size);

		&.vs__dropdown-option--highlight {
			background-color: var(--optionBackgroundColor) !important;
			color: #fff;
		}
	}

	.vs__actions .vs__clear svg {
		width: 14px;
		height: 14px;
	}
}
</style>

<style lang="css">
#container-instant .doctor-form .ql-editor {
	height: 5vh !important;
	overflow: auto !important;
	white-space: pre-wrap !important;
	overflow-wrap: break-word !important;
	word-break: break-word !important;
	box-sizing: border-box;
	width: 100%;
}

#container-instant .doctor-form .ql-toolbar.ql-snow {
	padding: 0.188rem 8px !important;
}

#container-instant .doctor-form .ql-snow .ql-picker.ql-size {
	width: 2.813rem !important;
}

#container-instant .doctor-form .ql-container.ql-snow:focus-within,
#container-instant .doctor-form .ql-container.ql-snow:has(.ql-editor:not(.ql-blank)) {
	border-color: var(--color-font) !important;
	background-color: var(--backgroundColor) !important;
}

#container-instant .doctor-form .ql-container.ql-snow {
	background-color: var(--backgroundColor) !important;
}

#container-instant .doctor-form .ql-container.ql-snow:focus-within .ql-editor,
#container-instant .doctor-form .ql-container.ql-snow:has(.ql-editor:not(.ql-blank)) .ql-editor {
	background-color: var(--backgroundColor) !important;
	color: var(--fontColor) !important;
	caret-color: var(--fontColor) !important;
	border-radius: 0 0 8px 8px !important;
}
</style>